import { useTheme } from "@/app/theme";
import { Toaster as Sonner } from "sonner";

export function Toaster() {
  const { resolved } = useTheme();
  return (
    <Sonner
      position="bottom-right"
      theme={resolved}
      toastOptions={{
        classNames: {
          toast: "bg-surface text-fg border border-border rounded-md text-xs",
        },
      }}
    />
  );
}
